// extracted by mini-css-extract-plugin
export var brand = "_1v-9";
export var compact = "_1v-6";
export var extraSmall = "_1v-7";
export var icon = "_1v-0";
export var large = "_1v-4";
export var light = "_1v-1";
export var medium = "_1v-5";
export var outline = "_1v-b";
export var primaryDark = "_1v-a";
export var primaryLight = "_1v-8";
export var primaryModern = "_1v-c";
export var success = "_1v-2";
export var successSolid = "_1v-3";